import { t } from "i18next";
import * as yup from "yup";

import { yupLocaleNoEntityContext } from "./yup-locale";

yup.setLocale(yupLocaleNoEntityContext(t));

export default yup;
